import React from 'react';

const WhyChoosePrograms = ({ data }) => {
  if (!data) {
    console.warn('WhyChoosePrograms: data prop is undefined');
    return null;
  }

  const { id, heading, items } = data;

  return (
    <section id={id} className="w-full bg-white py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Heading ── */}
        <h2
          className="text-center ava-heading-md mb-10 md:mb-14"
        >
          {heading}
        </h2>

        {/* ── 2-column grid ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {items.map((item) => (
            <WhyCard key={item.id} item={item} />
          ))}
        </div>

      </div>
    </section>
  );
};

/* ── Individual card ── */
const WhyCard = ({ item }) => (
  <div
    className="flex flex-row items-center gap-4 rounded-2xl p-4 md:p-5 ava-card-bg"
  >
    {/* ── Left image ── */}
    <div
      className="flex-shrink-0 rounded-xl overflow-hidden"
      style={{ width: '100px', height: '90px' }}
    >
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-full object-cover object-center"
        draggable={false}
      />
    </div>

    {/* ── Right text ── */}
    <div className="flex flex-col gap-1.5 flex-1 min-w-0">
      <a
        href={item.href || '#'}
        className="ava-text-subheading hover:opacity-80 transition-opacity duration-200"
      >
        {item.title}
      </a>
      <p
        className="ava-text-sm"
      >
        {item.description}
      </p>
    </div>
  </div>
);

export default WhyChoosePrograms;